import {stringify} from 'qs'
import request from 'crm/utils/request'
import {format} from 'utils/index'
import api from 'crm/common/api/employee-welcome-msg'

export async function getList(payload) {
    return request(`${api.getList.url}?${stringify(payload)}`)
}

export async function addUser(payload = {}) {
    return request(api.addUser.url, {
        method: api.addUser.type,
        body: payload.body,
    })
}

export async function editUser(payload = {}) {
    return request(format(api.editUser.url, {id: payload.id}), {
        method: api.editUser.type,
        body: payload.body,
    })
}

export async function deleteUser(payload = {}) {
    return request(format(api.deleteUser.url, {id: payload.id}), {
        method: api.deleteUser.type,
        body: payload.body,
    })
}

export async function downloadTemplate() {
    return request(`${api.downloadTemplate.url}?t=${new Date().getTime()}`, null, {
        returnResponse: true,
    })
}

export async function importGroupLink(payload) {
    return request(api.importGroupLink.url, {
        method: api.importGroupLink.type,
        body: payload.body,
    })
}
